<template>
    <div class="dashboard-objetivos-mensuales">
      <b-row>
        <b-col sm="12" lg="12">
          <div class="dashboard-tabla-resultados">
            <div class="dashboard-tabla-resultados-header">
              <h4>Objetivos Mensuales <span v-if="actualizarResultados"><i @click.stop="getResultados" class="fa fa-undo"></i></span></h4>
              <p class="description">Objetivo de ventas sin reembolsos. Facturación estimada sin reembolsos.</p>
              <!-- <p class="description">Mes actual</p> -->
            </div>
            <div class="dashboard-tabla-resultados-data">
              <b-table hover
                  responsive="sm" 
                  :class="{ 
                    'registro' : true, 
                    'rb-real': consultarRentabilidadBrutaReal
                  }"
                  :busy="tableBusy"
                  :items="objetivosMensuales" 
                  :fields="objetivosMensualesFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>
                <template v-slot:cell(periodo)="data">
                  {{ data.item.periodo | mesNombre }}
                </template>
                <!-- <template v-slot:cell(pjeObjetivoVentas)>
                </template> -->
                <template v-slot:cell(objetivoVentas)="data">
                  {{ data.item.objetivoVentas | moneda }}
                </template>
                <template v-slot:cell(objetivoRentabilidadBruta)="data">
                  {{ data.item.objetivoRentabilidadBruta | porcentaje }}
                </template>
                <template v-slot:cell(importeFacturar)="data">
                  {{ data.item.importeFacturar | moneda }}
                </template>
                <template v-slot:cell(importeFacturado)="data">
                  {{ data.item.importeFacturado | moneda }}
                </template>
                <template v-slot:cell(rentabilidadBrutaEstimada)="data">
                  {{ data.item.rentabilidadBrutaEstimada | porcentaje }}
                </template>
                <template v-slot:cell(rentabilidadBrutaReal)="data">
                  <template v-if="consultarRentabilidadBrutaReal">
                    {{ data.item.rentabilidadBrutaReal | porcentaje }}
                  </template>
                  <template v-else> --.-- </template>
                </template>

                <template v-slot:cell(progreso)="data">
                  <div class="indicadores">
                    <chart-pje-objetivo-ventas descripcion="" :pjeActual="data.item.pjeActualObjetivoVentas" />
                    <template v-if="consultarRentabilidadBrutaReal">
                      <chart-pje-objetivo-rentabilidad-bruta descripcion="" :pjeActual="data.item.pjeActualObjetivoRentabilidadBruta" />
                    </template>
                    <template v-else>
                      <chart-pje-objetivo-rentabilidad-bruta-estimada descripcion="" :pjeActual="data.item.pjeActualObjetivoRentabilidadBrutaEstimada" />
                    </template>
                  </div>
                </template>

                <template v-slot:cell(opciones)="data">
                  <template>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item @click.stop="exportarFacturacionEstimadaClientes(data.item)">
                        <i class="fa fa-file-excel-o"></i>Exportar Facturación Estimada</b-dropdown-item>
                      <b-dropdown-item @click.stop="exportarPresupuestosRentabilidadBrutaEstimadaPeriodo(data.item)">
                        <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Estimada</b-dropdown-item>
                      <b-dropdown-item
                          v-if="consultarRentabilidadBrutaReal"
                          @click.stop="exportarPresupuestosRentabilidadBrutaRealPeriodo(data.item)">
                        <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Real</b-dropdown-item>
                      <b-dropdown-item @click.stop="exportarVentasPeriodo(data.item)">
                        <i class="fa fa-file-excel-o"></i>Exportar Ventas</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </template>

                <template v-slot:cell(detailShowing)="row">
                  <b-btn class="detailShowing" 
                      size="sm" 
                      @click.stop="row.toggleDetails">
                    {{ ( row.detailsShowing) ? '-' : '+' }}
                  </b-btn>
                </template>

                <template v-slot:row-details="row">
                  <b-table hover
                      responsive="sm" 
                      :class="{ 
                        'table-dashboard' : true, 
                        'clientes': true, 
                        'rb-real': consultarRentabilidadBrutaReal 
                      }"
                      :busy="tableBusy"
                      :items="row.item.clientes" 
                      :fields="clientesFields">
                    <div slot="table-busy" class="text-center">
                      <b-spinner class="table-spinner" label="Spinning" />
                    </div>              
                    <template v-slot:cell(cliente)="data">
                      {{ data.item.cliente }} - {{ data.item.pjeObjetivoVentas | porcentaje }}
                    </template>
                    <template v-slot:cell(objetivoVentas)="data">
                      {{ data.item.objetivoVentas | moneda }}
                    </template>
                    <template v-slot:cell(objetivoRentabilidadBruta)="data">
                      {{ data.item.objetivoRentabilidadBruta | porcentaje }}
                    </template>
                    <template v-slot:cell(importeFacturar)="data">
                      {{ data.item.importeFacturar | moneda }}
                    </template>
                    <template v-slot:cell(importeFacturado)="data">
                      {{ data.item.importeFacturado | moneda }}
                    </template>
                    <template v-slot:cell(rentabilidadBrutaEstimada)="data">
                      {{ data.item.rentabilidadBrutaEstimada | porcentaje }}
                    </template>
                    <template v-slot:cell(rentabilidadBrutaReal)="data">
                      <template v-if="consultarRentabilidadBrutaReal">
                        {{ data.item.rentabilidadBrutaReal | porcentaje }}
                      </template>
                      <template v-else> --.-- </template>
                    </template>
                    <template v-slot:cell(opciones)="data">
                      <template>
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                          <template slot="button-content">
                            <i class="fa fa-ellipsis-v"></i>
                          </template>
                          <b-dropdown-item @click.stop="exportarFacturacionEstimadaCliente(data.item)">
                            <i class="fa fa-file-excel-o"></i>Exportar Facturación Estimada</b-dropdown-item>
                          <b-dropdown-item @click.stop="exportarPresupuestosRentabilidadBrutaEstimada(data.item)">
                            <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Estimada</b-dropdown-item>
                          <b-dropdown-item
                              v-if="consultarRentabilidadBrutaReal"
                              @click.stop="exportarPresupuestosRentabilidadBrutaReal(data.item)">
                            <i class="fa fa-file-excel-o"></i>Exportar Presupuestos RB Real</b-dropdown-item>
                          <b-dropdown-item @click.stop="exportarVentasCliente(data.item)">
                            <i class="fa fa-file-excel-o"></i>Exportar Ventas</b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </template>
                  </b-table>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import ChartPjeObjetivoVentas from '../ChartPjeObjetivo.vue';
import ChartPjeObjetivoRentabilidadBruta from '../ChartPjeObjetivo.vue';
import ChartPjeObjetivoRentabilidadBrutaEstimada from '../ChartPjeObjetivo.vue';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep';

export default {
  components: {
    ChartPjeObjetivoVentas,
    ChartPjeObjetivoRentabilidadBruta,
    ChartPjeObjetivoRentabilidadBrutaEstimada,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    consultarRentabilidadBrutaReal: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      key: 0,
      tableBusy: false,

      objetivosMensuales: [],
      objetivosMensualesFields: [],
      clientesFields: [],

      actualizarResultados: false
    }
  },
  created() {
    this.actualizarResultados = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadoresActualizarResultados'));

    this.objetivosMensualesFields = [
      {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
      },
      { key: 'periodo' },
      { 
        key: 'objetivoVentas',
        label: 'Obj. Ventas',
        class: 'text-right'
      },
      { 
        key: 'objetivoRentabilidadBruta',
        label: 'Obj. RB',
        class: 'text-right'
      },
      { 
        key: 'importeFacturar',
        label: 'Facturar',
        class: 'text-right'
      },
      { 
        key: 'importeFacturado',
        label: 'Facturado',
        class: 'text-right'
      },
      { 
        key: 'rentabilidadBrutaEstimada',
        label: 'RB Est.',
        class: 'text-right'
      }
    ];

    this.clientesFields = [
      {
          key: 'col1',
          label: '',
      },
      { key: 'cliente' },
      { 
        key: 'objetivoVentas',
        label: 'Obj. Ventas',
        class: 'text-right'
      },
      { 
        key: 'objetivoRentabilidadBruta',
        label: 'Obj. RB',
        class: 'text-right'
      },
      { 
        key: 'importeFacturar',
        label: 'Facturar',
        class: 'text-right'
      },
      { 
        key: 'importeFacturado',
        label: 'Facturado',
        class: 'text-right'
      },
      { 
        key: 'rentabilidadBrutaEstimada',
        label: 'RB Est.',
        class: 'text-right'
      }
    ];
    
    if (this.consultarRentabilidadBrutaReal) {
      this.objetivosMensualesFields.push(
        { 
          key: 'rentabilidadBrutaReal',
          label: 'RB Real',
          class: 'text-right'
        }
      );

      this.clientesFields.push(
        { 
          key: 'rentabilidadBrutaReal',
          label: 'RB Real',
          class: 'text-right'
        }
      );
    }

    this.objetivosMensualesFields.push(
      { 
        key: 'progreso',
        label: 'Progreso Vtas / RB',
        class: 'text-center'
      },
      { 
        key: 'opciones',
        label: '',
        class: 'text-center'
      }
    );
    this.clientesFields.push(
      { 
        key: 'progreso',
        label: '',
        class: 'text-center'
      },
      { 
        key: 'opciones',
        label: '',
        class: 'text-center'
      }
    );
  },
  computed: {
    objetivosMensualesFromStore() {
      return this.$store.getters['resultadosComercial/objetivosMensuales'];
    }
  },  
  methods: {
    getResultados() {
      this.tableBusy = true;
      this.$store.dispatch('resultadosComercial/getObjetivosMensuales')
        .then(() => {
          this.objetivosMensuales = this.$store.getters['resultadosComercial/objetivosMensuales'];
        })
        .finally(() => this.tableBusy = false);
    },
    // loadGrilla() {
    //   this.objetivosMensuales = cloneDeep(this.$store.getters['resultadosComercial/objetivosMensuales']);
    // },
    exportarPresupuestosRentabilidadBrutaEstimada(item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaEstimada', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Estimada';
            let fileName = 'resumen-rentabilidad-bruta-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaReal(item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }

      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaReal', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Real';
            let fileName = 'resumen-rentabilidad-bruta-real';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasCliente (item) {
      let params = {
        clienteId: item.clienteId,
        fechaDesde: moment(item.periodo).format('YYYY-MM-DD'),
        fechaHasta: moment(item.periodo).add(1, 'months').add(-1, 'days').format('YYYY-MM-DD'),
      }

      // console.log(item.periodo, new Date(item.periodo), new Date(item.periodo).toISOString())

      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getRptVentaMensualCliente', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosVentas/resultados'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas-cliente';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];
            // if ((/true/i).test(params.discriminarReembolsos)) {
            //   format.push({ titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            // }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaEstimadaPeriodo(item) {
      console.log(item);
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaEstimada', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Estimada';
            let fileName = 'resumen-rentabilidad-bruta-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarPresupuestosRentabilidadBrutaRealPeriodo(item) {
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }

      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getPresupuestosRentabilidadBrutaReal', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptPresupuestos = this.$store.getters['resultadosComercial/resultados'];

          if (rptPresupuestos) {
            if (rptPresupuestos.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Rentabilidad Bruta Real';
            let fileName = 'resumen-rentabilidad-bruta-real';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Fecha Registro', nombre: 'fechaRegistro', formato: 'fecha' },
              { titulo: 'Accion', nombre: 'accion', formato: '' },
              { titulo: 'Total', nombre: 'cotizacionTotal', formato: '' },
              { titulo: 'Ordenes', nombre: 'ordenes', formato: '' },
              { titulo: 'Pje.Rentab.Promedio', nombre: 'pjeRentabilidadPromedio', formato: '' },
            ];

            this.exportXLS(title, fileName, rptPresupuestos, format);
            
          } else {
            this.showErrorMsj ('No hay datos para exportar.');
          }
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    exportarVentasPeriodo (item) {
      let params = {
        clienteId: 0,
        fechaDesde: moment(item.periodo).format('YYYY-MM-DD'),
        fechaHasta: moment(item.periodo).add(1, 'months').add(-1, 'days').format('YYYY-MM-DD'),
      }

      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getRptVentaMensualCliente', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let ventas = this.$store.getters['resultadosVentas/resultados'];

          if (ventas) {
            if (ventas.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas-periodo';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputacion', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Número', nombre: 'numeroCompleto', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total', nombre: 'total', formato: '' },
              { titulo: 'Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' }
            ];
            // if ((/true/i).test(params.discriminarReembolsos)) {
            //   format.push({ titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' });
            // }

            this.exportXLS(title, fileName, ventas, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    exportarFacturacionEstimadaCliente (item) {
      let params = {
        clienteId: item.clienteId,
        periodo: item.periodo
      }
      this.exportarFacturacionEstimada(params);
    },
    exportarFacturacionEstimadaClientes(item) {
      let params = {
        clienteId: 0,
        periodo: item.periodo
      }
      this.exportarFacturacionEstimada(params);
    },
    exportarFacturacionEstimada (params) {
      this.showSpinner();
      this.$store.dispatch('resultadosComercial/getFacturacionEstimada', params)
        .then(() => {
          let exportXls = Boolean(false); 
          let facturacionEstimada = this.$store.getters['resultadosComercial/resultados'];

          if (facturacionEstimada) {
            if (facturacionEstimada.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Facturacion Estimada';
            let fileName = 'facturacion-estimada';
            let format = [
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
              { titulo: 'Acción', nombre: 'accion', formato: '' },
              { titulo: 'Fact.Estimada', nombre: 'importe', formato: '' },
              { titulo: 'Facturado', nombre: 'importeFacturado', formato: '' },
              { titulo: 'Saldo', nombre: 'saldo', formato: '' },
            ];

            this.exportXLS(title, fileName, facturacionEstimada, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

  },
  watch: {
    objetivosMensualesFromStore: {
      handler(newValue) {
        this.objetivosMensuales = cloneDeep(newValue);
      },
      immediate: true,
      deep: true
    }
  },  
}
</script>

<style>
/*
  .dashboard-comercial .row {
    margin-bottom: 30px;
  }
*/
  .dashboard-chart .description {
    font-size: 12px;
    font-style: italic;
  }

  .dashboard-objetivos-mensuales table {
    position: relative;
    top: 20px;
  }
  .dashboard-objetivos-mensuales table thead th {
    border-top: none;
  }
  .dashboard-objetivos-mensuales table tbody tr td {
    padding-top: 10px;
    padding-bottom: 5px;
    /* vertical-align: middle; */
    vertical-align: top;
  }

  /* Incluye RB Real */
  .dashboard-objetivos-mensuales table td[aria-colindex="1"] {
    width: 40px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .dashboard-objetivos-mensuales table td[aria-colindex="2"] {
    /* width: calc(37% - 50px); */
    width: calc(48% - 200px);
  }
  .dashboard-objetivos-mensuales table td[aria-colindex="3"],
  .dashboard-objetivos-mensuales table td[aria-colindex="5"],
  .dashboard-objetivos-mensuales table td[aria-colindex="6"] {
    width: 12%;
  }
  .dashboard-objetivos-mensuales table td[aria-colindex="4"],
  .dashboard-objetivos-mensuales table td[aria-colindex="7"] {
    width: 8%;
  }
  .dashboard-objetivos-mensuales table td[aria-colindex="8"] {
    /* width: 14%; */
    width: 130px;
  }
  .dashboard-objetivos-mensuales table td[aria-colindex="9"] {
    width: 30px;
    padding-left: 5px;
    padding-right: 5px;    
  }

  /* Incluye RB Real */
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="1"] {
    width: 40px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="2"] {
    /* width: calc(29% - 50px); */
    /* width: calc(35% - 50px); */
    width: calc(40% - 200px);
  }
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="3"],
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="5"],
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="6"] {
    width: 12%;
  }
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="4"],
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="7"],
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="8"] {
    width: 8%;
  }
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="9"] {
    /* width: 14%; */
    /* width: calc(8% - 20px); */
    width: 130px;
  }
  .dashboard-objetivos-mensuales .rb-real table td[aria-colindex="10"] {
    width: 30px;
    padding-left: 5px;
    padding-right: 5px;
  }


  .dashboard-objetivos-mensuales table .b-table-details td {
    padding-left: 0;
    padding-right: 0;
  }

  .dashboard-objetivos-mensuales table .b-table-details table {
    margin-top: 5px;
  }
  .dashboard-objetivos-mensuales table .b-table-details table thead {
    display: none;
  }
  .dashboard-objetivos-mensuales table .b-table-details table tbody tr:first-of-type td {
    border-top: none;
  }
  .dashboard-objetivos-mensuales table .b-table-details table tbody td {
    padding-left: 12px;
    padding-right: 12px;
  }

  .dashboard-objetivos-mensuales h4 span {
    font-size: 0.6em;
    cursor: pointer;
  }

  /* .dashboard-objetivos-mensuales .dashboard-tabla-resultados-data {
    min-height: 300px !important;
  }
  .dashboard-objetivos-mensuales .dashboard-tabla-resultados-data .pje-avance {
    margin-bottom: 5px;
  }
  .dashboard-objetivos-mensuales .dashboard-tabla-resultados-data .pje-avance p {
    margin-top: 0;
    margin-bottom: 0;
  } */
  /* .dashboard-objetivos-mensuales .dashboard-tabla-resultados-data .indicadores {
    padding-top: 5px;
  } */
  .dashboard-objetivos-mensuales .dashboard-tabla-resultados-data .indicadores .chart-pje-objetivo {
    /* margin-top: 0; */
    margin-bottom: 5px;
  }
</style>


